import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=306e7cf3&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Tips.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Tips.vue?vue&type=style&index=2&id=306e7cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e7cf3",
  null
  
)

export default component.exports